export default function (data) {

  let index = data.index

  let perfectList = []
  let perfectObj = data.value.perfect

  for (let i in index) {
    perfectList.push(perfectObj[index[i]])
  }

  let modelList = []
  let modelObj = data.value.model

  for (let i in index) {
    modelList.push(modelObj[index[i]])
  }

  let randomList = []
  let randomObj = data.value.random

  for (let i in index) {
    randomList.push(randomObj[index[i]])
  }

  const dataCollection = {
    labels: index,
    datasets: [
      {
        label: '完璧な予測',
        fill: false,
        data: perfectList,
        pointRadius: 0,
        backgroundColor: '#99aee2',
        borderColor: '#99aee2',
        pointBackgroundColor: '#2456d4',
        pointBorderColor: '#2456d4',
        pointHoverBackgroundColor: '#2456d4',
        pointHoverBorderColor: '#2456d4'
      },
      {
        label: 'このモデルの予測',
        fill: false,
        data: modelList,
        pointRadius: 0,
        backgroundColor: '#dca4ac',
        borderColor: '#dca4ac',
        pointBackgroundColor: '#d8243e',
        pointBorderColor: '#d8243e',
        pointHoverBackgroundColor: '#d8243e',
        pointHoverBorderColor: '#d8243e'
      },
      {
        label: 'ランダムな予測',
        fill: false,
        data: randomList,
        pointRadius: 0,
        backgroundColor: '#9cdfa5',
        borderColor: '#9cdfa5',
        pointBackgroundColor: '#10be29',
        pointBorderColor: '#10be29',
        pointHoverBackgroundColor: '#10be29',
        pointHoverBorderColor: '#10be29'
      }
    ]
  }

  const options = {
    responsive: false,
    title: {
      display: false
    },
    legend: {
      display: false
    },
    scales: {
      yAxes: [
        {
          id: 'y',
          position: 'left',
          scaleLabel: {
            display: true,
            labelString: '累積発生率',
            fontSize: 16
          },
          ticks: {
            max: 1,
            min: 0
          }
        }
      ],
      xAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            labelString: '高 ← スコア順 → 低',
            fontSize: 16
          },
          ticks: {
            max: 100,
            min: 0,
            showLine: false,
            maxRotation: 0
          }
        }
      ]
    }
  }

  return {
    type: 'line',
    data: dataCollection,
    options: options
  }
}



// WEBPACK FOOTER //
// ./src/modules/chart/cap.js